import { useState } from 'react';
import { useTemplateManagement } from '../../hooks/useTemplateManagement';

export const useAddTemplateDialog = () => {
  const { templates } = useTemplateManagement();
  const [templateName, setTemplateName] = useState('');
  const [validationError, setValidationError] = useState<string | null>(null);

  // Validate template name
  const validateTemplateName = (name: string): string | null => {
    // Check if name is empty
    if (!name || name.trim().length === 0) {
      return 'Template name is required';
    }

    // Check if name is too long
    if (name.length > 50) {
      return 'Template name must be 50 characters or less';
    }

    // Check if name already exists (case-insensitive)
    const nameExists = templates.some(
      t => t.name.toLowerCase() === name.trim().toLowerCase()
    );

    if (nameExists) {
      return 'Template name already exists';
    }

    return null;
  };

  // Handle template name change
  const handleTemplateNameChange = (name: string): void => {
    setTemplateName(name);
    // Clear validation error when user starts typing
    if (validationError) {
      setValidationError(null);
    }
  };

  // Handle form submit
  const handleSubmit = (): boolean => {
    const error = validateTemplateName(templateName);

    if (error) {
      setValidationError(error);
      return false;
    }

    return true;
  };

  // Reset form
  const handleClose = (): void => {
    setTemplateName('');
    setValidationError(null);
  };

  return {
    templateName,
    setTemplateName: handleTemplateNameChange,
    validationError,
    handleSubmit,
    handleClose,
  };
};
